<div class="dashboard-container">
  <div class="top-grid">

    @if (!editView) {
      <p class="m-0">Displaying insights from <strong>{{ fromDate | date: 'dd/MM/yyyy' }} </strong> to <strong>{{ toDate |
          date: 'dd/MM/yyyy' }}</strong></p>
      <button mat-button color="primary" (click)="editView = true" 
        >Change</button>
    } @else {
      <!-- Date Range Picker -->
      <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="date-range-picker">
        <mat-label>Enter date range</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" (click)="applyDateChange()" [disabled]="!range.valid"
        class="apply-button">Apply</button>
      <button mat-button color="primary" (click)="editView = false"
        >Cancel</button>
    }

    <!-- Show loading indicator while fetching suppliers -->
    <div *ngIf="isSuppliersLoading" class="supplier-loading">
      Loading switch providers...
    </div>

    <!-- Show error message if no suppliers found -->
    <div *ngIf="!isSuppliersLoading && noSuppliersFound" class="supplier-error">
      No switch providers found. Please try again later.
    </div>

    <!-- Only show the supplier dropdown if more than one supplier is available -->
    <mat-form-field *ngIf="!isSuppliersLoading && !noSuppliersFound && supplierOptions.length > 1" appearance="outline"
      [subscriptSizing]="'dynamic'">
      <mat-label>Select switch provider</mat-label>
      <mat-select [(value)]="selectedSupplier" (selectionChange)="onSupplierChange()">
        <mat-option *ngFor="let supplier of supplierOptions" [value]="supplier.value">
          {{ supplier.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- When only one supplier is available, display it without dropdown -->
    <div *ngIf="!isSuppliersLoading && !noSuppliersFound && supplierOptions.length === 1" class="supplier-single">
      Switch Provider: <strong>{{ supplierOptions[0].label }}</strong>
    </div>
  </div>

  <!-- Show content only if suppliers are loaded successfully -->
  <div *ngIf="!isSuppliersLoading && !noSuppliersFound" class="unified-grid">
    <!-- Metrics Cards - now with updated data-area attributes -->
    <app-metrics-card class="metrics-card" data-area="metric1"
      [value]="metrics.totalSwitches.value"
      [trend]="metrics.totalSwitches.trend"
      [subValues]="[
        { label: 'Retention', value: metrics.retentionSwitches.value ?? 0 },
        { label: 'Acquisition', value: metrics.acquisitionSwitches.value ?? 0 },
        { label: 'Dual fuel', value: metrics.dualFuelSwitches.value ?? 0 },
        { label: 'Elec only', value: metrics.elecOnlySwitches.value ?? 0 }
      ]"
      label="Total Switches">
    </app-metrics-card>

    <app-metrics-card class="metrics-card" data-area="metric2"
      [value]="metrics.totalMPANs.value"
      [trend]="metrics.totalMPANs.trend"
      [subValues]="[{ label: 'Smart Meters', value: metrics.smartMeterMPANs.value ?? 0 }]" 
      label="Total MPANs">
    </app-metrics-card>
    
    <app-metrics-card class="metrics-card" data-area="metric3"
      [value]="metrics.totalMPRNs.value"
      [trend]="metrics.totalMPRNs.trend"
      [subValues]="[{ label: 'Smart Meters', value: metrics.smartMeterMPRNs.value ?? 0 }]" 
      label="Total MPRNs">
    </app-metrics-card>

    <!-- New Energy Supplier Chart -->
    @if (isChartsLoading || newEnergySupplierChart.series) {
    <mat-card class="chart-card" data-area="energy" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isChartsLoading" class="loading">Loading...</div>
        <div *ngIf="!isChartsLoading && !newEnergySupplierChart.series" class="no-data">No data available</div>
        <highcharts-chart *ngIf="!isChartsLoading && newEnergySupplierChart.series" [Highcharts]="Highcharts"
          [constructorType]="chartConstructor" [options]="newEnergySupplierChart" [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card>
    }

    <!-- Region Wise Chart -->
    <!-- @if (isChartsLoading || regionWiseChart.series) {
      <mat-card class="chart-card" data-area="region" appearance="outlined">
        <mat-card-content>
          <div *ngIf="isChartsLoading" class="loading">Loading...</div>
          <div *ngIf="!isChartsLoading && !regionWiseChart.series" class="no-data">No data available</div>
          <highcharts-chart class="no-stretch" *ngIf="!isChartsLoading && regionWiseChart.series"
            [Highcharts]="Highcharts"
            [constructorType]="chartConstructor"
            [options]="regionWiseChart"
            [update]="updateFlag">
          </highcharts-chart>
        </mat-card-content>
      </mat-card>
    } -->

    @if (isMapLoading || regionWiseMapChart.series) {
    <mat-card class="chart-card" data-area="region" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isMapLoading" class="loading">Loading...</div>
        <div *ngIf="!isMapLoading && !regionWiseMapChart.series" class="no-data">No data available</div>
        <highcharts-chart *ngIf="!isMapLoading && regionWiseMapChart.series" [Highcharts]="Highcharts"
          [constructorType]="'mapChart'" [options]="regionWiseMapChart" [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card>
    }

    <!-- Tariff Type Chart -->
    @if (isChartsLoading || tariffTypeChart.series) {
    <mat-card class="chart-card" data-area="tariff" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isChartsLoading" class="loading">Loading...</div>
        <div *ngIf="!isChartsLoading && !tariffTypeChart.series" class="no-data">No data available</div>
        <highcharts-chart class="no-stretch" *ngIf="!isChartsLoading && tariffTypeChart.series"
          [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="tariffTypeChart"
          [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card>
    }

    <!-- Switch Type Chart -->
    @if (isChartsLoading || switchTypeChart.series) {
    <mat-card class="chart-card" data-area="switch" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isChartsLoading" class="loading">Loading...</div>
        <div *ngIf="!isChartsLoading && !switchTypeChart.series" class="no-data">No data available</div>
        <highcharts-chart class="no-stretch" *ngIf="!isChartsLoading && switchTypeChart.series"
          [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="switchTypeChart"
          [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card>
    }

    <!-- Day Wise Chart -->
    @if (isChartsLoading || dayWiseChart.series) {
    <mat-card class="chart-card" data-area="daily" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isChartsLoading" class="loading">Loading...</div>
        <div *ngIf="!isChartsLoading && !dayWiseChart.series" class="no-data">No data available</div>
        <highcharts-chart class="no-stretch" *ngIf="!isChartsLoading && dayWiseChart.series" [Highcharts]="Highcharts"
          [constructorType]="chartConstructor" [options]="dayWiseChart" [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card>
    }

    <!-- Switch Status Chart -->
    @if (isChartsLoading || switchStatusChart.series) {
    <mat-card class="chart-card" data-area="status" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isChartsLoading" class="loading">Loading...</div>
        <div *ngIf="!isChartsLoading && !switchStatusChart.series" class="no-data">No data available</div>
        <highcharts-chart class="no-stretch" *ngIf="!isChartsLoading && switchStatusChart.series"
          [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="switchStatusChart"
          [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card>
    }

    <!-- Switch Count Chart -->
    <!-- <mat-card class="chart-card" data-area="count" appearance="outlined">
      <mat-card-content>
        <div *ngIf="isChartsLoading" class="loading">Loading...</div>
        <div *ngIf="!isChartsLoading && !switchCountChart.series" class="no-data">No data available</div>
        <highcharts-chart class="no-stretch" *ngIf="!isChartsLoading && switchCountChart.series"
          [Highcharts]="Highcharts"
          [constructorType]="chartConstructor"
          [options]="switchCountChart"
          [update]="updateFlag">
        </highcharts-chart>
      </mat-card-content>
    </mat-card> -->

    <!-- Switch Age Data Table -->
    @if (isSwitchAgeLoading || displayData().length) {
    <mat-card class="chart-card" data-area="table" appearance="outlined">
      <mat-card-content>
        @if (isSwitchAgeLoading) {
        <div class="loading">Loading...</div>
        }
        @else if (!isSwitchAgeLoading && displayData().length) {
        <p class="text-center" [ngStyle]="switchAgeData.title.style">
          {{ switchAgeData.title.text }} from {{ switchAgeFromDate | date: 'dd/MM/yyyy' }} to {{ toDate | date:
          'dd/MM/yyyy' }}
        </p>
        <app-table [data]="displayData()" [columns]="tableColumns()" [config]="tableConfig"></app-table>
        }
        @else {
        <div class="no-data">No data available</div>
        }
      </mat-card-content>
    </mat-card>
    }

    <!-- Switch Status Summary Table -->
    @if (isStatusSummaryLoading || switchStatusSummaryTableData()) {
    <mat-card class="chart-card" data-area="summary" appearance="outlined">
      <mat-card-content>
        @if (isStatusSummaryLoading) {
        <div class="loading">Loading...</div>
        }
        @else if (!isStatusSummaryLoading && switchStatusSummaryTableData()) {
        <div class="table-header">
          <p class="text-center table-title">Switch Status Summary</p>
          <button mat-raised-button color="primary" (click)="downloadPendingSwitchIds()" class="download-btn" [disabled]="isPendingIdsLoading">
            <mat-icon>download</mat-icon>
            Download Pending Switch IDs
          </button>
        </div>
        <app-data-table
          [tableData]="switchStatusSummaryTableData()"
          [config]="switchStatusSummaryConfig">
        </app-data-table>
        }
        @else {
        <div class="no-data">No data available</div>
        }
      </mat-card-content>
    </mat-card>
    }
  </div>
</div>